var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"appear":"","mode":"out-in"},on:{"enter":_vm.enter,"leave":_vm.leave}},[_c('keep-alive',[_c('router-view',_vm._b({key:_vm.$route.path,ref:"view"},'router-view',_vm.viewProps,false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }